

import React, { useState } from 'react';
import type { FieldValidation } from '@rjsf/utils';
import { getDefaultFormState } from '@rjsf/utils';

import { useApi, identityApiRef, configApiRef } from '@backstage/core-plugin-api'; // ¡Importaciones clave!
import { withTheme } from '@rjsf/core';
import { Theme as RJSFTheme } from '@rjsf/material-ui'; // or '@rjsf/material-ui' if using material-ui v4
import validator from '@rjsf/validator-ajv8'; // Necesitas un validador (AJV es el estándar)
import { Button } from '@material-ui/core';
import { createScaffolderFieldExtension, scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { deepMergeAtMatchingKeys, buildOutputsPrefill } from '../../catalog/EntityTabs/CICDContent/quickCdConfig';

const Form = withTheme(RJSFTheme);


export const DynamicFormGeneratorFieldCD = (props: any) => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const SYS_INFO_BACKEND_URL = 'backend.baseUrl';
  const backendUrl = config.getString(SYS_INFO_BACKEND_URL);

  // Access the template config from the global form data (from previous step)
  // In Backstage scaffolder, previous step data is available through formContext
  const formContext = (props as any).formContext;
  const globalFormData = formContext?.formData || {};
  const templateConfig = globalFormData.templateConfig;
  const selectedBranch = templateConfig?.branch;
  const selectedTemplate = templateConfig?.template;
  const selectedVersion = templateConfig?.version;
  const artifactoryOutputs = templateConfig?.artifactoryOutputs;
  const skipInfraDropdown = templateConfig?.skipInfraDropdown;
  // Values the user typed in the quick-config step (RepoConfigEditor):
  // {section: {field: value}}. Applied AFTER the infra outputs merge so the
  // precedence is user > infra outputs > schema defaults.
  const userOverrides = templateConfig?.userOverrides;


  const [schema, setSchema] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  // localFormData is the source of truth for RJSF  bypasses its uncontrolled behaviour
  const [localFormData, setLocalFormData] = useState<any>(props.formData || {});
  // Incrementing this key forces RJSF to remount and re-initialise from localFormData
  const [formKey, setFormKey] = useState(0);
  const autofillAppliedRef = React.useRef(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Auto-fill: deep-merges Terraform output values into the schema's default
  // structure, then re-applies the quick-step user values on top (precedence:
  // user > infra outputs > schema defaults).
  // Uses getDefaultFormState as base when localFormData is still empty (RJSF hasn't fired onChange yet).
  React.useEffect(() => {
    if ((!artifactoryOutputs && !userOverrides) || !schema || autofillAppliedRef.current) return;

    // Use localFormData if RJSF has already populated it, otherwise compute schema defaults
    const base = (localFormData && Object.keys(localFormData).length > 0)
      ? localFormData
      : getDefaultFormState(validator, schema, {}, schema);

    if (!base || Object.keys(base as any).length === 0) return;

    const prefill = buildOutputsPrefill(artifactoryOutputs);
    if (!prefill && !userOverrides) return;

    let newFormData = prefill ? deepMergeAtMatchingKeys(base, prefill) : base;
    if (userOverrides && typeof userOverrides === 'object') {
      newFormData = deepMergeAtMatchingKeys(newFormData, userOverrides);
    }
    autofillAppliedRef.current = true;
    setLocalFormData(newFormData);
    setFormKey(prev => prev + 1);
    props.onChange(newFormData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artifactoryOutputs, userOverrides, schema]);

  const handleSubmit = async () => {
    // Protección extra contra doble click
    if (isSubmitting) {
      return;
    }

    try {
      setIsSubmitting(true);

      // Ejecuta submit del padre
      await props.onSubmit();
    } catch (error) {
      console.error('Error during submit:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  React.useEffect(() => {
    // Solo llamar a la API si template y version están definidos y no vacíos
    if (selectedTemplate && selectedVersion && selectedBranch) {
      fetchSchema(selectedTemplate, selectedVersion, selectedBranch);
    }
    // Si solo hay template pero no version, no hacer nada
  }, [selectedTemplate, selectedVersion, selectedBranch]);

  const fetchSchema = async (template: string, version: string, branch: string) => {
    setLoading(true);
    try {
      const token = (await identityApi.getCredentials()).token;
      const response = await fetch(`${backendUrl}/api/devops-api-proxy/template-payload/${template}/${version}?templateBranch=${encodeURIComponent(branch)}&metadata=false`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const payloadData = await response.json();

      // Extract the schema from the editorSchema field
      const editorSchema = payloadData.editorSchema;
      if (!editorSchema) {
        throw new Error('No editorSchema found in the response');
      }

      setSchema(editorSchema);
    } catch (error) {
      console.error('Error fetching schema:', error);
      setSchema(null);
    } finally {
      setLoading(false);
    }
  };

  // Handle form data changes from the dynamic form
  const handleFormChange = (data: any) => {
    setLocalFormData(data.formData);
    props.onChange(data.formData);
  };

  // Render the dynamic form or loading/error states
  return (
    <div style={{
      // border: '2px solid #1976d2', 
      padding: '20px',
      margin: '10px 0',
      // backgroundColor: '#2a3244ff',
      borderRadius: '8px'
    }}>
      {/* <h3 style={{ margin: '0 0 15px 0', color: '#1976d2' }}>
         Configuration for {selectedTemplate || 'Unknown Template'} v{selectedVersion || 'Unknown'}
      </h3> */}

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p> Loading schema for {selectedTemplate} v{selectedVersion}...</p>
        </div>
      )}

      {!loading && !schema && selectedTemplate && selectedVersion && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#d32f2f' }}>
          <p> Failed to load schema for {selectedTemplate} v{selectedVersion}</p>
          <button
            onClick={() => fetchSchema(selectedTemplate, selectedVersion, selectedBranch)}
            style={{
              padding: '8px 16px',
              // backgroundColor: '#1976d2', 
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
             Retry
          </button>
        </div>
      )}

      {(!selectedTemplate || !selectedVersion) && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#ff9800' }}>
          <p> Please select a template and version in the previous step</p>
        </div>
      )}

      {/* For helm-deploy-gke: wait for infra component selection before showing the form (only when infra dropdown is shown) */}
      {!loading && schema && selectedTemplate === 'helm-deploy-gke' && !artifactoryOutputs && !skipInfraDropdown && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#1976d2' }}>
          <p>Selecciona un componente de infraestructura en el selector de arriba para continuar</p>
        </div>
      )}

      {schema && (selectedTemplate !== 'helm-deploy-gke' || !!artifactoryOutputs || !!skipInfraDropdown) && (
        <div>
          <div style={{
            // backgroundColor: '#373a46ff', 
            padding: '15px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '10px' // Reduced font size for the entire form
          }}>
            <Form
              key={formKey}
              schema={schema}
              formData={localFormData || {}}
              onChange={handleFormChange}
              onSubmit={handleSubmit}
              validator={validator}
              showErrorList={false}
              liveValidate={true}
              uiSchema={{
                businessAppId: { "ui:readonly": true },
                projectId: { "ui:readonly": true },
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {/* Hide the submit button since scaffolder handles submission */}
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export const DynamicFormGeneratorFieldCDD = (props: any) => {
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const SYS_INFO_BACKEND_URL = 'backend.baseUrl';
  const backendUrl = config.getString(SYS_INFO_BACKEND_URL);

  // Access the template config from the global form data (from previous step)
  // In Backstage scaffolder, previous step data is available through formContext
  const formContext = (props as any).formContext;
  const globalFormData = formContext?.formData || {};
  const templateConfig = globalFormData.templateConfig;
  const selectedBranch = templateConfig?.branch;
  const selectedTemplate = templateConfig?.template;
  const selectedVersion = templateConfig?.version;
  const artifactoryOutputs = templateConfig?.artifactoryOutputs;


  const [schema, setSchema] = useState(null);
  const [loading, setLoading] = useState(false);
  // localFormData is the source of truth for the RJSF Form  bypasses RJSF's uncontrolled behaviour
  const [localFormData, setLocalFormData] = useState<any>(props.formData || {});
  // Incrementing this key forces RJSF to remount and re-initialise from localFormData
  const [formKey, setFormKey] = useState(0);
  const autofillAppliedRef = React.useRef(false);

  // Auto-fill: waits for RJSF to fire its first onChange (which populates localFormData with
  // schema defaults), then deep-merges Terraform output values into the correct nested location.
  React.useEffect(() => {
    if (!artifactoryOutputs) return;
    if (autofillAppliedRef.current) return;
    if (!localFormData || Object.keys(localFormData).length === 0) return;

    const prefill = buildOutputsPrefill(artifactoryOutputs);
    if (!prefill) return;

    const newFormData = deepMergeAtMatchingKeys(localFormData, prefill);
    autofillAppliedRef.current = true;
    setLocalFormData(newFormData);
    setFormKey(prev => prev + 1); // Force RJSF to reinitialise with the new data
    props.onChange(newFormData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artifactoryOutputs, localFormData]);

  React.useEffect(() => {
    // Solo llamar a la API si template y version están definidos y no vacíos
    if (selectedTemplate && selectedVersion && selectedBranch) {
      fetchSchema(selectedTemplate, selectedVersion, selectedBranch);
    }
    // Si solo hay template pero no version, no hacer nada
  }, [selectedTemplate, selectedVersion, selectedBranch]);

  const fetchSchema = async (template: string, version: string, branch: string) => {
    setLoading(true);
    try {
      const token = (await identityApi.getCredentials()).token;
      const response = await fetch(`${backendUrl}/api/devops-api-proxy/template-payload/${template}/${version}?templateBranch=${encodeURIComponent(branch)}&metadata=false`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const payloadData = await response.json();

      // Extract the schema from the editorSchema field
      const editorSchema = payloadData.editorSchema;
      if (!editorSchema) {
        throw new Error('No editorSchema found in the response');
      }

      setSchema(editorSchema);
    } catch (error) {
      console.error('Error fetching schema:', error);
      setSchema(null);
    } finally {
      setLoading(false);
    }
  };

  // Handle form data changes from the dynamic form
  const handleFormChange = (data: any) => {
    setLocalFormData(data.formData);
    props.onChange(data.formData);
  };

  // Render the dynamic form or loading/error states
  return (
    <div style={{
      // border: '2px solid #1976d2', 
      padding: '20px',
      margin: '10px 0',
      // backgroundColor: '#2a3244ff',
      borderRadius: '8px'
    }}>
      {/* <h3 style={{ margin: '0 0 15px 0', color: '#1976d2' }}>
         Configuration for {selectedTemplate || 'Unknown Template'} v{selectedVersion || 'Unknown'}
      </h3> */}

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p> Loading schema for {selectedTemplate} v{selectedVersion}...</p>
        </div>
      )}

      {!loading && !schema && selectedTemplate && selectedVersion && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#d32f2f' }}>
          <p> Failed to load schema for {selectedTemplate} v{selectedVersion}</p>
          <button
            onClick={() => fetchSchema(selectedTemplate, selectedVersion, selectedBranch)}
            style={{
              padding: '8px 16px',
              // backgroundColor: '#1976d2', 
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
             Retry
          </button>
        </div>
      )}

      {(!selectedTemplate || !selectedVersion) && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#ff9800' }}>
          <p> Please select a template and version in the previous step</p>
        </div>
      )}

      {schema && (
        <div>
          <div style={{
            // backgroundColor: '#373a46ff', 
            padding: '15px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '10px' // Reduced font size for the entire form
          }}>
            <Form
              key={formKey}
              schema={schema}
              formData={localFormData || {}}
              onChange={handleFormChange}
              validator={validator}
              showErrorList={false}
              liveValidate={true}
              uiSchema={{
                businessAppId: { "ui:readonly": true },
                projectId: { "ui:readonly": true },
              }}
            >
              <div style={{ display: 'none' }}>
                {/* Hide the submit button since scaffolder handles submission */}
                <button type="submit">Submit</button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export const dinamicFormGeneratorCaseValidation = (
  value: string,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('This field is required.');
    return;
  }
};

// Create the extension using the proper plugin pattern
export const DynamicFormGeneratorCaseFieldExtensionCD = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DynamicFormGeneratorFieldCD', // Must match ui:field in template.yaml
    component: DynamicFormGeneratorFieldCDD,
    validation: dinamicFormGeneratorCaseValidation,
  }),
);
